import { propOr } from "ramda";



export const renderUserEmailSelectOption = propOr("", "email");
